interface TrackOnSiteSearchParams {
  value: unknown;
  trackOnSiteSearch?: (params: { searchVal: string; searchPos: string }) => void;
  searchPos: string;
}

export const trackSiteSearch = ({ value, trackOnSiteSearch, searchPos }: TrackOnSiteSearchParams): void => {
  if (value && trackOnSiteSearch) {
    const searchVal = typeof value === 'string' ? value : Array.isArray(value) ? value.join(', ') : String(value);
    trackOnSiteSearch({ searchVal, searchPos });
  }
};
